import * as React from 'react';

function SvgArrowRight(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.375 7.568L7.63 1.712a.286.286 0 00-.188-.07h-1.58a.142.142 0 00-.093.25l6.254 5.43H1.572a.143.143 0 00-.143.142v1.071c0 .079.064.143.143.143H12.02l-6.254 5.429c-.1.087-.04.25.093.25h1.634a.137.137 0 00.093-.036l6.79-5.89a.572.572 0 000-.863z"
        fill="#000"
        fillOpacity={0.45}
      />
    </svg>
  );
}

export default SvgArrowRight;
